const getMessage = (questionType) => {
  switch (questionType) {
    case "matrix":
      return "Por favor ingrese un valor para todas las casillas.";
    case "options":
      return "Por favor seleccione una opción.";
    default:
      return "Por favor ingrese un valor válido.";
  }
};

const QuestionInvalidInputMessage = ({ questionType }) => {
  const message = getMessage(questionType);

  return (
    <div className="card-footer">
      <i className="fas fa-exclamation-triangle mr-4" />
      {message}
    </div>
  );
};

export default QuestionInvalidInputMessage;
